module.exports = __webpack_public_path__ + "static/9gag-e821dc058cf51a993fd0fd72bfb5931d.svg";